import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { PfepService } from '../../services/pfepService';
import { TranslateService } from '@ngx-translate/core';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { RackAddData, NoubaAddData } from '../../models/pfepModels';

@Component({
  selector: 'app-add-rack-nouba-popup',
  templateUrl: './add-rack-nouba-popup.component.html',
  styleUrls: ['./add-rack-nouba-popup.component.scss']
})
export class AddRackNoubaPopupComponent implements OnInit {
  displayedRackColumns = [
    'rackCode',
    'drivingDirection',
    'x',
    'y',
    'depth',
    'width',
    'height',
    'building',
    'shelfCount',
    'columnCount'
  ];
  displayedNoubaColumns = [
    'noubaCode',
    'drivingDirection',
    'x',
    'y',
    'depth',
    'width',
    'building'
  ];
  public dataSource;

  public addRackData: RackAddData = {
    rackCode: '',
    building: null,
    columnCount: null,
    drivingDirection: null,
    shelfCount: null,
    user: '',
    x: null,
    y: null,
    depth: '',
    width: '',
    height: ''
  };

  public addNoubaData: NoubaAddData = {
    noubaCode: '',
    building: null,
    drivingDirection: null,
    user: '',
    x: null,
    y: null,
    depth: null,
    width: null
  };
  // ************************* Rack Form Details *********************
  buildingNumberList = [];
  selectedBuildingNumber = new FormControl('', [Validators.required]);
  rackCodeControl = new FormControl({ value: '',disabled:false }, [
    Validators.required,
    Validators.pattern('^[A-Za-z0-9]+$'),
    Validators.minLength(7),
    Validators.maxLength(7)
  ]);
  rackdrivingDirectionControl = new FormControl('', [
    Validators.required,
    Validators.pattern(/^-?(0|[0-9]\d*)?$/)
  ]);
  rackXControl = new FormControl('', [
    Validators.required,
    Validators.pattern(/^[0-9]\d*(\.\d+)?$/)
  ]);
  rackYControl = new FormControl('', [
    Validators.required,
    Validators.pattern(/^[0-9]\d*(\.\d+)?$/)
  ]);
  rackDepthControl = new FormControl('', [
    Validators.required,
    Validators.pattern(/^[0-9]\d*(\.\d+)?$/)
  ]);
  rackWidthControl = new FormControl('', [
    Validators.required,
    Validators.pattern(/^[0-9]\d*(\.\d+)?$/)
  ]);
  rackHeightControl = new FormControl('', [
    Validators.required,
    Validators.pattern(/^[0-9]\d*(\.\d+)?$/)
  ]);
  rackShelfCountControl = new FormControl('', [
    Validators.required,
    Validators.pattern(/^-?(0|[0-9]\d*)?$/)
  ]);
  rackColumnCountControl = new FormControl('', [
    Validators.pattern(/^-?(0|[0-9]\d*)?$/)
  ]);
  rackAddForm: FormGroup;

  // *****************Nouba Form Details***************
  noubaCodeControl = new FormControl({ value: '',disabled:false }, [
    Validators.required,
    ,
    Validators.pattern('^[A-Za-z0-9]+$'),
    Validators.minLength(3),
    Validators.maxLength(3)
  ]);
  noubadrivingDirectionControl = new FormControl('', [
    Validators.required,
    Validators.pattern(/^-?(0|[0-9]\d*)?$/)
  ]);
  noubaXControl = new FormControl('', [
    Validators.required,
    Validators.pattern(/^[0-9]\d*(\.\d+)?$/)
  ]);
  noubaYControl = new FormControl('', [
    Validators.required,
    Validators.pattern(/^[0-9]\d*(\.\d+)?$/)
  ]);
  noubaDepthControl = new FormControl('', [
    Validators.required,
    Validators.pattern(/^[0-9]\d*(\.\d+)?$/)
  ]);
  noubaWidthControl = new FormControl('', [
    Validators.required,
    Validators.pattern(/^[0-9]\d*(\.\d+)?$/)
  ]);
  noubaAddForm: FormGroup;
  addRackSuccess = false;
  addRackError = false ;
  addRackErrorMessage: any;
  addNoubaSuccess = false;
  addNoubaError = false ;
  addNoubaErrorMessage: any;
  deleteNoubaSuccess = false;
  deleteNoubaError = false;
  deleteRackSuccess = false;
  deleteRackError = false;
  confirmDeleteRack = false;
  confirmDeleteNouba = false;
  constructor(
    public dialogRef: MatDialogRef<AddRackNoubaPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private spinner: NgxSpinnerService,
    private pfepService: PfepService,
    private translate: TranslateService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.rackAddForm = new FormGroup({
      rackCode: this.rackCodeControl,
      drivingDirection: this.rackdrivingDirectionControl,
      x: this.rackXControl,
      y: this.rackYControl,
      depth: this.rackDepthControl,
      width: this.rackWidthControl,
      height: this.rackHeightControl,
      shelfCount: this.rackShelfCountControl,
      columnCount: this.rackColumnCountControl,
      building: this.selectedBuildingNumber
    });

    this.noubaAddForm = new FormGroup({
      noubaCode: this.noubaCodeControl,
      drivingDirection: this.noubadrivingDirectionControl,
      x: this.noubaXControl,
      y: this.noubaYControl,
      depth: this.noubaDepthControl,
      width: this.noubaWidthControl,
      building: this.selectedBuildingNumber
    });

    if (this.data.type === 'AddRackData') {
      const rackAddData = [];
      rackAddData.push(this.addRackData);
      this.dataSource = new MatTableDataSource(rackAddData);
    } else if (this.data.type === 'AddNoubaData') {
      const noubaAddData = [];
      noubaAddData.push(this.addNoubaData);
      this.dataSource = new MatTableDataSource(noubaAddData);
    }
    this.getBuildingNumbers();
  }
  getBuildingError(value) {
    return value.hasError('required') ? this.translate.instant('Required') : '';
  }
  getRequiredNumberErrorMessage(value) {
    return value.hasError('required')
      ? this.translate.instant('Required')
      : value.hasError('pattern')
      ? this.translate.instant('Only Numbers Allowed')
      : '';
  }
  getRackErrorMessage(value) {
    return value.hasError('required')
      ? 'Required'
      : value.hasError('pattern')
      ? 'Only Alphanumeric Allowed'
      : value.hasError('minlength')
      ? 'Minimun 7 characters'
      : value.hasError('maxlength')
      ? 'Maximum 7 characters'
      : '';
  }
  getNoubaErrorMessage(value) {
    return value.hasError('required')
      ? 'Required'
      : value.hasError('pattern')
      ? 'Only Alphanumeric Allowed'
      : value.hasError('minlength')
      ? 'Minimun 3 characters'
      : value.hasError('maxlength')
      ? 'Maximum 3 characters'
      : '';
  }
  getErrorMessage(value) {
    return value.hasError('pattern')
      ? this.translate.instant('Only Numbers Allowed')
      : '';
  }
  getBuildingNumbers() {
    this.pfepService.getBuildingData().subscribe(response => {
      const buildingNumberArray = response.result;
      if (response.status && response.status.statusCode === 200) {
        this.buildingNumberList = [
          ...this.buildingNumberList,
          ...buildingNumberArray
        ];
      }
    });
  }
  onNoClick(): void {
    setTimeout(function() {}, 1000);
    this.data.noubaCode = [];
    this.data.rackCode = [];
    this.dialogRef.close('updateData');
  }
  confirmAdd(type) {
    if (type === 'AddRackData') {
      this.addRackData.building = this.rackAddForm.value.building;
      this.addRackData.user = JSON.parse(localStorage.getItem('currentUser'));
      this.addRackInformation(this.addRackData);
    } else {
      this.addNoubaData.building = this.noubaAddForm.value.building;
      this.addNoubaData.user = JSON.parse(localStorage.getItem('currentUser'));
      this.addNoubaInformation(this.addNoubaData);
    }
    // console.log(type, this.addRackData, this.rackAddForm.value);
  }
  addRackInformation(rackData) {
    this.spinner.show();
    this.pfepService.addRackDetails(rackData).subscribe(
      response => {
        this.addRackSuccess = true;
        this.addRackError = false;
        this.spinner.hide();
      },
       error => {
        if (error.status === 422) {
          this.spinner.hide();
          this.addRackSuccess = false;
          this.addRackError = true;
          this.addRackErrorMessage = error.error.result;
        } else if (error.status === 409) {
          this.spinner.hide();
          this.addRackSuccess = false;
          this.addRackError = true;
          this.addRackErrorMessage = error.error.result;
        }  else {
          this.spinner.hide();
        }
      });
  }
  addNoubaInformation(noubaData) {
    this.spinner.show();
    this.pfepService.addNoubaDetails(noubaData).subscribe(
      response => {
        this.addNoubaSuccess = true;
          this.addNoubaError = false;
        this.spinner.hide();
      },
      error => {
        if (error.status === 422) {
          this.spinner.hide();
          this.addNoubaSuccess = false;
          this.addNoubaError = true;
          this.addNoubaErrorMessage = error.error.result;
        } else if (error.status === 409) {
          this.spinner.hide();
          this.addNoubaSuccess = false;
          this.addNoubaError = true;
          this.addNoubaErrorMessage = error.error.result;
        } else {
          this.spinner.hide();
        }
      });
  }
  askRackDeleteConfirmation() {
    this.confirmDeleteRack = true;
  }
  confirmRackDelete() {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.spinner.show();
    this.pfepService.deletRackDetails(this.data.rackCode, currentUser).subscribe(response => {
      this.deleteRackSuccess = true;
      this.deleteNoubaError = false;
      this.confirmDeleteRack = false;
      this.spinner.hide();
    }, error => {
      this.deleteRackSuccess = false;
      this.deleteNoubaError = true;
      this.confirmDeleteRack = false;
      this.spinner.hide();
    });
  }
  askNoubaDeleteConfirmation() {
    this.confirmDeleteNouba = true;
  }
  confirmNoubaDelete(noubaCode) {
    console.log(noubaCode);
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.spinner.show();
    // const noubaCodeArray = [];
    // noubaCodeArray.push(noubaCode);
    this.pfepService.deletNoubaDetails(this.data.noubaCode, currentUser).subscribe(response => {
      this.deleteNoubaSuccess = true;
      this.deleteNoubaError = false;
      this.confirmDeleteNouba = false;
      this.spinner.hide();
    }, error => {
      this.deleteNoubaSuccess = false;
      this.deleteNoubaError = true;
      this.confirmDeleteNouba = false;
      this.spinner.hide();
    });
  }
}
